import { API } from "aws-amplify";



export const hashCode = function (str) {
    str = String(str);
    let hash = 0,
      i,
      chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(36);
  };

export const onSendInvitebyEmail = async ({ contacts, user, referral }) => {
    let payload = contacts.map((i) => ({
        id: i.id,
        email: i.email,
    }));

    return API.post('api', '/users/send-notification', {
        body: {
            data: {
                user_id: user.id,
                referral_code: referral.referral_code,
                contacts: payload,
            },
            skipTemplates: true,
            topic: 'REFERRAL_SEND_INVITE',
        },
    });
};

export const onSendInvitebyPhone = async ({ contacts, user, referral }) => {
    let payload = contacts.map((i) => ({
        id: i.id,
        phone: i.phone,
        fullName: i.first_name,
    }));
    return API.post('api', '/users/send-notification', {
        body: {
            data: {
                user_id: user.id,
                referral_code: referral.referral_code,
                payload,
            },
            skipTemplates: true,
            topic: 'REFERRAL_SEND_INVITE_BYPHONE',
        },
    });
};
